import { MeasurementVariant, Position } from '../../../shared/types/protocol.ts';


/**
 * Find existing positions with a positive measurement count in a plan variant.
 * Return IDs so filtering preserves the indexes used for selection and editing.
 */
export function getVariantPositions(
    positions: Position[],
    variant: MeasurementVariant | undefined,
): ReadonlySet<number> {
    const measuredPositions = positions.filter(position => (variant?.positions[position.id] ?? 0) > 0);
    const positionIds = new Set(measuredPositions.map(position => position.id));
    return positionIds;
}
